module.exports = __webpack_public_path__ + "static/about-img-5f4faf4aee09f6ec44cb60fb6e4a80a9.webp";